<nav class="navbar navbar-expand navbar-theme">
	<ng-content></ng-content>
</nav>
